import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';

var RadioSvg = function (props) {
    var handleStyleProps = useTheme().handleStyleProps;
    var id = props.id, _a = props.themeKey, themeKey = _a === void 0 ? "radioSvg" : _a, forwardProps = __rest(props, ["id", "themeKey"]);
    var svgCssProps = handleStyleProps(forwardProps, {
        themeKey: themeKey,
        baseStyle: { boxSizing: "border-box" },
    });
    return (jsxs("svg", __assign({}, svgCssProps, { viewBox: "0 0 100 100", id: id, "data-testid": id }, { children: [jsx("circle", { className: "focus", cx: "50", cy: "50", r: "50", fill: "#CCE0F5" }), jsx("circle", { className: "radio", cx: "50", cy: "50", r: "37", fill: "#FFFFFF", stroke: "#BFBFBF", strokeWidth: "5" }), jsx("circle", { className: "check", cx: "50", cy: "50", r: "18", fill: "#404040" })] })));
};

export { RadioSvg };
//# sourceMappingURL=RadioSvg.js.map
